export const DATE_FORMAT_PLAN_COMPLETION_TIME_TASK_SINGLE_VOYAGE= 'DD.MM.YYYY HH:mm'
